import React from "react";
import useSWR from "swr";

export function useLocationData(
    locationApiUrl: string | null,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    const locationFetcher = React.useCallback(
        (url: string) =>
            fetchGlobal(url, { method: "GET" }) as Promise<
                LocationManagementResult
            >,
        [fetchGlobal]
    );

    const { data: locationData } = useSWR<LocationManagementResult>(
        locationApiUrl,
        locationFetcher
    );

    const existingDesignationsSet = React.useMemo(() => {
        const rows: Places = Array.isArray(locationData?.data)
            ? locationData.data
            : [];
        return new Set(
            rows.map((loc: Place) =>
                (loc.designation ?? loc["Désignation"] ?? "")
                    .toString()
                    .trim()
                    .toLowerCase()
            )
        );
    }, [locationData]);

    return { locationData, existingDesignationsSet };
}
